import React, { useState } from 'react';
import './CalculatorPage.css';

function AngelNumberMeaningChecker() {
  const [angelNumber, setAngelNumber] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const getMeaning = (num) => {
    // Placeholder for Angel Number Meaning logic
    // This will need to be replaced with actual angel number interpretations
    switch (num) {
      case 111:
        return "111: A sign of alignment and new beginnings. Your thoughts are manifesting quickly.";
      case 222:
        return "222: Trust the process and have faith. Things are working out for your highest good.";
      case 333:
        return "333: The ascended masters are with you, offering support and guidance.";
      case 444:
        return "444: You are surrounded by angels. They are supporting and guiding you.";
      case 555:
        return "555: Significant changes are coming. Embrace them with an open heart.";
      case 666:
        return "666: A call to rebalance your thoughts and focus on spirituality.";
      case 777:
        return "777: Good fortune and spiritual growth are on their way. Keep up the good work.";
      case 888:
        return "888: Abundance and prosperity are flowing into your life. Financial blessings are near.";
      case 999:
        return "999: A cycle is completing, and you are ready to move on to a new phase.";
      default:
        return "Please enter a common angel number (e.g., 111, 222, 333, etc.) for an explanation.";
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    const num = parseInt(angelNumber, 10);
    if (isNaN(num)) {
      setError('Please enter a valid number.');
      return;
    }

    setResult(getMeaning(num));
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Angel Number Meaning Checker",
    "description": "Discover the spiritual meaning and message behind angel numbers.",
    "url": "https://www.yourwebsite.com/angel-number-meaning-checker",
    "potentialAction": {
      "@type": "CalculateAction",
      "name": "Check Angel Number Meaning",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/angel-number-meaning-checker?number={angelNumber}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": "required name=angelNumber"
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Angel Number Meaning Checker</h1>
      <p className="text-center">Enter an angel number to understand its spiritual message.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="angelNumber">Angel Number:</label>
          <input
            type="number"
            id="angelNumber"
            className="form-control"
            value={angelNumber}
            onChange={(e) => setAngelNumber(e.target.value)}
            placeholder="e.g., 111, 222, 333"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Check Meaning</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Meaning:</h2>
          <p className="result-explanation">{result}</p>
        </div>
      )}
    </div>
  );
}

export default AngelNumberMeaningChecker;
